import { MemberView } from './MemberView';

export class PODShuffleMember extends MemberView {
  podShuffleMemberId: number;

  podShuffleStatus?: string;

  podShuffleErrorType?: string;

  constructor(obj: any) {
    super(obj);
    this.podShuffleMemberId = obj.id;
    this.id = obj.memberId;
    this.podShuffleStatus = obj.podShuffleStatus;
    this.podShuffleErrorType = obj.podShuffleErrorType;
  }
}

export default PODShuffleMember;
